import React from 'react'

export default function FullRow(props) {
  const size = props.size || 'small-12'

  return (
    <div className="row">
      <div className={`columns ${size}`}>
        {props.children}
      </div>
    </div>
  )
}

FullRow.displayName = 'FullRow'
